import { ACTIONS_INBOUND_EMAIL_LOG } from '../_constants/inboundEmailLog.constants';

const initialState = {
  byId: {},
};

export function inboundEmailLogReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_INBOUND_EMAIL_LOG.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_INBOUND_EMAIL_LOG.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_INBOUND_EMAIL_LOG.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default inboundEmailLogReducer;
